var map = {
	"./affaere1/religion-icon.svg": 34558,
	"./affaerentreff/religion-icon.svg": 4604,
	"./casualxdates/religion-icon.svg": 23103,
	"./ficktreffpunkt24/religion-icon.svg": 8009,
	"./fremdgehboerse/religion-icon.svg": 66641,
	"./illicitoasis/religion-icon.svg": 62334,
	"./religion-icon.svg": 64072,
	"./seitensprungtreff69/religion-icon.svg": 80502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21190;